//eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';

export const helpContent = {
  title: 'BITE DB Help',
  description:
    'Use BITE DB to manage entity and product databases, then screen them for regulatory, sanctions, and supply chain risk signals.',
  helpItems: [
    {
      title: 'Quick Start',
      isDefaultOpen: true,
      content: (
        <p>
          <ul>
            <li>Create a database from the BITE DB Dashboard.</li>
            <li>
              Add records (entities/products) for richer screening coverage.
            </li>
            <li>
              Run screenings from a database card or from individual edit
              screens.
            </li>
          </ul>
        </p>
      ),
    },
    {
      title: 'Creating a database',
      isDefaultOpen: false,
      content: (
        <>
          <p>
            Select Create Database from the top-right of the BITE DB Dashboard.
            Follow the wizard to set database info, upload bulk data, and
            configure settings.
          </p>
          <p>
            Tip: Use bulk upload when possible—more fields (aliases, locations,
            identifiers) generally improves match accuracy.
          </p>
        </>
      ),
    },
    {
      title: 'Viewing a database',
      isDefaultOpen: false,
      content: (
        <p>
          Open the Databases tab and click a database card to review its details
          and browse Entities or Products.
        </p>
      ),
    },
    {
      title: 'Adding records (entities or products)',
      isDefaultOpen: false,
      content: (
        <>
          <p>
            Open a database, then click the (+) Add icon in the top-right to
            launch the add-item wizard. Provide as much detail as possible for
            more complete screening.
          </p>
          <p>
            <ul>
              <li>Entities: names/aliases, country, identifiers</li>
              <li>Products: origin, manufacturer, category, HTS</li>
            </ul>
          </p>
        </>
      ),
    },
    {
      title: 'Editing records',
      isDefaultOpen: false,
      content: (
        <>
          <p>
            Open a record and select Edit to update profile details, notes, and
            compliance fields.
          </p>
          <p>
            <ul>
              <li>
                Edit an entity: update names, identifiers, notes, and risk
                metadata.
              </li>
              <li>
                Edit a product: update origin, classification, and compliance
                status.
              </li>
            </ul>
          </p>
        </>
      ),
    },
    {
      title: 'Classifying products (HTS)',
      isDefaultOpen: false,
      content: (
        <p>
          On a product record, click the Classify icon to open the classify
          wizard. Refine the HTS Code and save it back to the product for better
          tariff and screening results.
        </p>
      ),
    },
    {
      title: 'Running a screening',
      isDefaultOpen: false,
      content: (
        <>
          <p>Run screenings from either location:</p>
          <p>
            <ul>
              <li>
                From edit screens: use Run Screening while editing an
                entity/product.
              </li>
              <li>
                From a database: click the Run Screening action on the database
                card to start a new screening job.
              </li>
            </ul>
          </p>
        </>
      ),
    },
    {
      title: 'Deleting databases or records',
      isDefaultOpen: false,
      content: (
        <>
          <p>
            Delete a database: from the database view, click the Archive
            (trash/archive) icon and confirm.
          </p>
          <p>
            Delete a record: open the entity/product, choose the delete action,
            and confirm removal from the database.
          </p>
        </>
      ),
    },
    {
      title: 'Best practices for fewer false matches',
      isDefaultOpen: false,
      content: (
        <p>
          <ul>
            <li>Add aliases and identifiers (where available).</li>
            <li>
              Include country/region and industry/category fields to help
              disambiguate.
            </li>
            <li>
              Keep HTS codes updated for products so tariff logic and screening
              results stay consistent.
            </li>
          </ul>
        </p>
      ),
    },
  ],
};
